import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TournamentRoutingModule } from './tournament-routing.module';
import { TournamentComponent } from './tournament.component';

import { TournamentHomeComponent } from './components/home/home.component';
import { TournamentListComponent } from './components/list/list.component';
import { TournamentEnrollComponent } from './components/enroll/enroll.component';
import { TabGamesComponent } from './components/category-detail/tabs/games/games.component';
import { TabEnrollmentsComponent } from './components/category-detail/tabs/enrollments/enrollments.component';
import { TabClassificationComponent } from './components/category-detail/tabs/classification/classification.component';

import { TournamentCategoryDetailComponent } from './components/category-detail/category-detail.component';
import { GamesBracketComponent } from './components/category-detail/tabs/games-bracket/games-bracket.component';
import { MatchsComponent } from './components/category-detail/tabs/matchs/matchs.component';
import { ThemeModule } from 'src/app/@theme/theme.module';
import { TournamentAllComponent } from './components/all/all.component';
import { TournamentCategoriesComponent } from './components/categories/categories.component';
import { TournamentSelectCategoryComponent } from './components/select-category/select-category.component';
import { CancelSubscriptionComponent } from './components/cancel-subscription/cancel-subscription.component';
import { CancelSubscriptionTokenValidationComponent } from './components/cancel-subscription-token-validation/cancel-subscription-token-validation.component';
import { TournamentPlayerGamesComponent } from './components/player-games/player-games.component';
import { PlayerSelectionDialogComponent } from './components/player-selection-dialog/player-selection-dialog.component';
import { AuthModule } from '../auth/auth.module';

@NgModule({
    declarations: [
        TournamentComponent,
        TournamentHomeComponent,
        TournamentListComponent,
        TournamentEnrollComponent,
        TournamentCategoryDetailComponent,
        TabGamesComponent,
        TabEnrollmentsComponent,
        TabClassificationComponent,
        GamesBracketComponent,
        MatchsComponent,
        TournamentAllComponent,
        TournamentCategoriesComponent,
        TournamentSelectCategoryComponent,
        CancelSubscriptionComponent,
        CancelSubscriptionTokenValidationComponent,
        TournamentPlayerGamesComponent,
        PlayerSelectionDialogComponent,
    ],
    imports: [CommonModule, TournamentRoutingModule, ThemeModule],
})
export class TournamentModule {}
